import React from 'react';
import PartyMaster from './PartyMaster';

function ButtaCuttingParties() {
  return (
    <PartyMaster
      title="Butta Cutting Parties"
      modalTitle="Add Butta Cutting Party"
      addButtonText="Add Butta Cutting Party"
      searchPlaceholder="Search butta cutting parties..."
      partyCategory="BUTTA_CUTTING_PARTIES"
      namePlaceholder="Butta cutting party name"
    />
  );
}

export default ButtaCuttingParties;
